import React from "react";
import { BellRing } from "lucide-react";
import type { Alert } from "../../lib/types";
import { fmtDateTime } from "../../lib/utils";

const STAGE: Record<string, { label: string; cls: string }> = {
  t30: { label: "T-30", cls: "bg-amber-50 text-amber-800 ring-amber-200" },
  t7: { label: "T-7", cls: "bg-orange-50 text-orange-800 ring-orange-200" },
  t1: { label: "FINAL", cls: "bg-rose-50 text-rose-800 ring-rose-200" },
  expired: { label: "EXPIRED", cls: "bg-rose-600 text-white ring-rose-700" },
  unpaid: { label: "UNPAID", cls: "bg-orange-50 text-orange-800 ring-orange-200" },
  overdue: { label: "OVERDUE", cls: "bg-rose-600 text-white ring-rose-700" },
};

export function EscalationBadge({ a }: { a: Alert }) {
  const s = a.stage ? STAGE[a.stage] : null;
  return (
    <span className="flex flex-wrap items-center gap-1.5">
      {s && <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ring-1 ${s.cls}`} data-testid={`alert-stage-${a.id}`}>{s.label}</span>}
      {!!a.notify_count && (
        <span className="inline-flex items-center gap-1 text-[11px] text-slate-500" data-testid={`alert-notify-count-${a.id}`} title={a.last_notified_at ? `Last notified ${fmtDateTime(a.last_notified_at)}` : undefined}>
          <BellRing className="h-3 w-3" />{a.notify_count} reminder{a.notify_count === 1 ? "" : "s"}{a.last_notified_at ? ` · ${fmtDateTime(a.last_notified_at)}` : ""}
        </span>
      )}
    </span>
  );
}
